import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { environment } from '../../../environments/environment';
import { SignService } from './service/sign.service';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss']
})
export class SignComponent implements OnInit {

  subscriptionPost: Subscription;

  isDisabled: boolean = false;
  msgInfo: string = '';
  msgButton: string = 'Entrar';

  pass: any;
  mail: any;

  constructor(private signService: SignService, private router: Router) { }

  ngOnInit() {
  }

  doLogin() {

    if (!this.pass || !this.mail) {
      this.msgInfo = "Campos obrigatórios.";
      return;
    }

    this.msgInfo = "";
    this.msgButton = "carregando....";
    this.isDisabled = true;

    this.subscriptionPost = this.signService.login(this.mail, this.pass)
      .subscribe(succ => {
        let ret: any = succ;
        this.msgInfo = ret.messege;

        if (ret.success) {
          sessionStorage.setItem(environment.atoken, JSON.stringify({ token: ret.token, uid: ret.item.mail, name: ret.item.name, photo: ret.item.photo }));
          this.router.navigate(['/home']);
        }

        if (ret.item && ret.item.is_firstacess) {

          var user = { mail: ret.item.mail, old: this.pass };

          var id = btoa(JSON.stringify(user));

          this.router.navigate(['/login/change-pass', id]);
          return;
        }

      }, err => {
        this.msgInfo = "Erro ao realizar login!";

      }, () => {
        this.msgButton = "Entrar";
        this.isDisabled = false;
      });
  }

  goFogot() {
    this.router.navigate(['/login/forgot']);
  }

  ngOnDestroy() {
    if (this.subscriptionPost)
      this.subscriptionPost.unsubscribe();
  }

}